/**
 * Lightweight skeleton placeholder. Used by Hunt Mode while the lazy
 * tailored-resume + cover-letter LLM calls are in flight.
 *
 * Honours prefers-reduced-motion by collapsing the pulse to a static
 * muted block.
 */

export function Skeleton({ className = "" }: { className?: string }) {
	return (
		<div
			aria-hidden="true"
			className={`animate-pulse rounded-md bg-muted motion-reduce:animate-none ${className}`}
		/>
	);
}
